import { calculateFitToPageScale } from "../utils/pdfScalingUtils";
import { useCallback } from "react";

/**
 * Hook for PDF fit-to-page functionality
 * Provides a function to scale PDF to fit available container space
 */
const usePdfFitToPage = (canvasRef, pdfPageDimensions, setPdfScale) => {
  /**
   * Handle fit to page - scales PDF to optimally fit the available space
   */
  const handleFitToPage = useCallback(() => {
    if (!canvasRef.current || !pdfPageDimensions.current) return;

    const optimalScale = calculateFitToPageScale(
      canvasRef.current,
      pdfPageDimensions.current
    );

    if (optimalScale !== null) {
      setPdfScale(optimalScale);
    }
  }, [canvasRef, pdfPageDimensions, setPdfScale]);

  return {
    handleFitToPage,
  };
};

export default usePdfFitToPage;
